import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b21710b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "item__header" }, " Quantity: ", -1))
const _hoisted_2 = { class: "item__value" }

import { toRefs } from 'vue';
import { IAggregatedPlacement } from '@/const/types/placement';
import { BasicModelBasicInfoList } from '@/components/basic'
import {
  IonHeader,
  IonToolbar,
  IonButton,
  IonList,
  IonListHeader,
  IonModal,
  IonContent,
  IonButtons,
  IonLabel,
  IonItem,
} from '@ionic/vue';

interface Props {
  placements: IAggregatedPlacement[];
  isOpen: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlacementsListModal',
  props: {
    placements: null,
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  placements: IAggregatedPlacement[];
  isOpen: boolean;
};




const { isOpen } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), { "is-open": _unref(isOpen) }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "ion-padding h-90" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.placements, (placement, index) => {
            return (_openBlock(), _createBlock(_unref(IonList), {
              key: placement.id
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonListHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("Place " + _toDisplayString(index + 1) + ".", 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(BasicModelBasicInfoList), {
                  model: placement.place,
                  "additional-keys": ['name']
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_unref(IonItem), {
                      key: placement.quantity
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { class: "item__inner" }, {
                          default: _withCtx(() => [
                            _hoisted_1,
                            _createElementVNode("p", _hoisted_2, _toDisplayString(placement.quantity), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  ]),
                  _: 2
                }, 1032, ["model"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})